const MARQUEE_TEXT =
  "Nothing in the Way — A Memoir by Rahul Bhaskar — Available on Amazon and Kindle —";

export const EditorialMarquee = () => (
  <section
    className="marquee-shell"
    data-testid="editorial-marquee"
    aria-label={MARQUEE_TEXT}
  >
    <div className="marquee-track" aria-hidden="true">
      {[0, 1, 2, 3].map((item) => (
        <span key={item}>{MARQUEE_TEXT}</span>
      ))}
    </div>
  </section>
);